import { render, staticRenderFns } from "./editMenuCatalog.vue?vue&type=template&id=5f5e2c02"
import script from "./editMenuCatalog.vue?vue&type=script&lang=js"
export * from "./editMenuCatalog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports